import api from './apiUmbrellaSetup';

export const fetchMappedProduct = (productType, productId) => {
  return api(`/apps/doodly/app-to-cf-product-mapper/${productType}/${productId}`);
};

export default {
  fetchMappedProduct
};
